import React from "react";
import "../SelectData/styles.css";

export const SelectData = ({ selectedDate, onDateChange }) => {
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const parseDate = (dateString) => {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-");
    return new Date(year, month - 1, day);
  };

  const today = new Date();
  const maxDate = formatDate(today);

  return (
    <input
      type="date"
      className="form-control"
      value={selectedDate ? formatDate(selectedDate) : ""}
      onChange={(e) => onDateChange(parseDate(e.target.value))}
      max={maxDate}
    />
  );
};
